export default __webpack_public_path__ + "static/media/icon_logout.ae28a6e2.svg";